import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const FillingNotesDialog = ({ 
  open, 
  onClose, 
  onAcknowledge, 
  fillingNotes, 
  tenderInfo 
}) => {
  const handleAcknowledge = () => {
    onAcknowledge();
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <InfoIcon color="primary" />
          <Typography variant="h6">
            Important Filling Instructions
          </Typography>
        </Box>
      </DialogTitle>

      {tenderInfo && (
        <Box sx={{ px: 3 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Tender: {tenderInfo.company} (ID: {tenderInfo.id})
          </Typography>
        </Box>
      )}
      
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          Please read the following instructions before entering prices for this tender.
        </Alert>
        
        <Box 
          sx={{ 
            p: 2, 
            backgroundColor: '#f5f5f5', 
            borderRadius: 1,
            border: '1px solid #ddd',
            mb: 2
          }}
        >
          <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
            {fillingNotes}
          </Typography>
        </Box>
        
        <Alert severity="warning">
          <Typography variant="body2">
            <strong>Note:</strong> You must acknowledge these instructions before you can proceed with pricing.
            The instructions will remain visible under the tender information after acknowledgment.
          </Typography>
        </Alert>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button 
          onClick={onClose} 
          variant="outlined"
          color="inherit"
        >
          Cancel
        </Button>
        <Button 
          onClick={handleAcknowledge} 
          variant="contained"
          color="primary"
          autoFocus
        >
          I Acknowledge These Instructions
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FillingNotesDialog;